import { isReference } from '../../utilities/graphql/storeUtils.js';

function getTypenameFromStoreObject(store, objectOrReference) {
  return isReference(objectOrReference) ? store.getFieldValue(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}

export { getTypenameFromStoreObject };